import { ActionTree } from 'vuex';
import { RoleState } from './types';
import { RootState } from '@/store/types';
import api from '@/api';
import * as roleRequests from '@/api/requests/roles';
import Role from '@/api/models/role';

export const actions: ActionTree<RoleState, RootState> = {
    /**
     * Fetch all roles.
     *
     * @param commit
     * @param getters
     */
    async fetchRoles({ commit, getters }) {
        const response = await api.call(roleRequests.ALL(getters.httpFilters));
        commit('setRoles', response.data.data);
    },

    /**
     * Create a new role.
     *
     * @param commit
     * @param role
     */
    async createRole({ commit }, role: Role) {
        const response = await api.call(roleRequests.SAVE(role));
        commit('addRole', response.data.data);
    },

    /**
     * Update an existing role.
     *
     * @param commit
     * @param role
     */
    async updateRole({ commit }, role: Role) {
        if (!role.id) {
            throw new Error('No role id provided');
        }
        const response = await api.call(roleRequests.UPDATE(role.id, role));
        commit('addRole', response.data.data);
    },

    /**
     * Set active role.
     *
     * @param commit
     * @param getters
     * @param roleId
     */
    async setActiveRole({ commit, getters }, roleId: number) {
        const response = await api.call(roleRequests.FIND(roleId));
        commit('addRole', response.data.data);
        commit('setActiveRoleId', roleId);
    },
};
